/* RESPONSIBLE TEAM: team-standalone */
import Model, { attr } from '@ember-data/model';
import {
  ConnectionType,
  CONNECTION_TYPE_ICONS,
  CONNECTION_TYPE_DISPLAY_NAMES,
} from 'embercom/objects/environments/connection-types';
import type Integration from 'embercom/models/standalone/integration';
import type SalesforceConfiguration from 'embercom/models/standalone/salesforce-configuration';
import { type InterfaceIconName } from '@intercom/pulse/lib/interface-icons';

export default class Environment extends Model {
  @attr('number') declare connectionId: number;
  @attr('number') declare connectionType: ConnectionType;
  @attr('string') declare integrationIdentifier: string;
  @attr('boolean') declare defaultEnvironment: boolean;
  @attr('boolean') declare productionEnvironment: boolean;

  private get connection(): Integration {
    return this.store.peekRecord(
      'standalone/integration',
      `${this.connectionType}-${this.connectionId}`,
    );
  }

  get icon(): InterfaceIconName {
    return CONNECTION_TYPE_ICONS[this.connectionType] ?? 'info';
  }

  get label(): string {
    if (this.salesforceConfiguration) {
      return `${this.salesforceConfiguration.environmentLabel} - ${this.salesforceConfiguration.domain}`;
    }

    if (this.connectionType) {
      return CONNECTION_TYPE_DISPLAY_NAMES[this.connectionType] ?? String(this.connectionType);
    }

    return this.connection?.externalIdentifier;
  }

  get salesforceConfiguration(): SalesforceConfiguration | null {
    if (this.connectionType !== ConnectionType.SalesforceApi) {
      return null;
    }

    return this.store.peekRecord('standalone/salesforce-configuration', this.connectionId);
  }
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'standalone/environment': Environment;
  }
}
